import React from 'react';
import { Content, Page } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Box } from '@mui/material';
import { ArgusAppComponentEntity } from '@eng-portal/czi-extensions-common';
import { StackExplorer } from '../StackExplorer/StackExplorer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function ArgusStacksEntityTab(): JSX.Element {
  const { entity } = useEntity<ArgusAppComponentEntity>();

  const appName = entity.spec.app?.name;
  if (!appName) {
    throw new Error('App name not found in entity spec');
  }

  return (
    <Page themeId="tool">
      <Content noPadding>
        <Box paddingLeft={5} paddingTop={2} width={'99%'}>
          <StackExplorer appName={appName} />
        </Box>
      </Content>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        theme="dark"
      />
    </Page>
  );
}

